import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setCurrentRoute } from '../../redux/reducers/utils/navReducer';
import { useSelector } from 'react-redux';
import { checkAccess } from '../../core/utils';

const SettingsModule = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { accessComponentsForUser } = useSelector((store) => store.services);
  const accessToKitchensettings = checkAccess(accessComponentsForUser, 'moderation');

  useEffect(() => {
    if (accessToKitchensettings) {
      dispatch(setCurrentRoute('settings/kitchensettings'));
      navigate('/settings/kitchensettings');
    } else {
      dispatch(setCurrentRoute('settings/profile'));
      navigate('/settings/profile');
    }
  }, []);

  return null;
};

export default SettingsModule;